<template>
	<div
		class="container-wrap"
		:class="{ 'rtr_pay-exchange': true, 'mobile-layout': isMobile }"
	>
		<div class="container-box">
			<div class="card mb_10">
				<h3 class="title">
					<img
						:src="iconExchangeTitle"
						alt=""
						style="width: 20px; height: 20px"
					/>{{ $t('rtr_pay-exchange.title1') }}
				</h3>
			</div>
			<div class="card type1 mb_0">
				<div class="card_inner">
					<ul id="buySell" class="tab_area mb_40">
						<li
							:class="[{ selected: selectedTab === 'BID' }, 'buy']"
							@click="selectedTab = 'BID'"
						>
							<a>{{ $t('rtr_pay-exchange.tab1') }}</a>
						</li>
						<li
							:class="[{ selected: selectedTab === 'ASK' }, 'sell']"
							@click="selectedTab = 'ASK'"
						>
							<a>{{ $t('rtr_pay-exchange.tab2') }}</a>
						</li>
					</ul>

					<div class="exchange_wrap">
						<div class="mb_40">
							<div
								:class="
									isMobile
										? 'd_block select_area mb_20'
										: 'd_flex align_items_center mb_20'
								"
							>
								<div
									:class="
										isMobile ? 'source_box mobile-full mb_10' : 'w50 source_box'
									"
								>
									<CustomSelectBox
										ref="sourceSelect"
										:placeholder="sourcePlaceholder"
										:options="sourceAssets"
										:show-account="true"
										@selectItem="selectSourceAsset"
									></CustomSelectBox>
								</div>

								<div
									:class="
										isMobile ? 'space_arrow mobile-center' : 'space_arrow'
									"
								>
									<img
										src="@/assets/images/v2/icon/icon-equals.svg"
										alt="equals image"
									/>
								</div>

								<div
									:class="
										isMobile ? 'target_box mobile-full mt_10' : 'w50 target_box'
									"
								>
									<CustomSelectBox
										ref="targetSelect"
										:placeholder="targetPlaceholder"
										:show-account="true"
										:disable="targetDisable"
										:options="targetAssets"
										@selectItem="selectTargetAsset"
									></CustomSelectBox>
								</div>
							</div>
							<div :class="isMobile ? 'd_block mb_20' : 'd_flex mb_20'">
								<div :class="isMobile ? 'mobile-full mb_15' : 'w50'">
									<p class="mb_10" v-if="selectedTab === 'BID'">
										{{ $t('rtr_pay-exchange.text2') }}
									</p>
									<p class="mb_10" v-else>{{ $t('rtr_pay-exchange.text8') }}</p>
									<input
										type="text"
										v-model="sourceAmount"
										class="tar"
										placeholder="0"
										:disabled="amountDisable"
									/>
								</div>
								<div v-if="!isMobile" style="width: 30px"></div>
								<div :class="isMobile ? 'mobile-full' : 'w50'">
									<p class="mb_10">{{ $t('rtr_pay-exchange.text3') }}</p>
									<input
										type="text"
										v-model="targetAmount"
										class="tar"
										disabled
									/>
								</div>
							</div>
						</div>
						<div
							:class="isMobile ? 'buy_sell_box mb_15' : 'buy_sell_box mb_60'"
						>
							<div class="top_box">
								<div v-if="selectedTab === 'BID'">
									<p>{{ $t('rtr_pay-exchange.text4') }}</p>
									<p>
										{{ !selectedMarket ? 0 : selectedMarket.bid_spread_rate }} %
									</p>
								</div>
								<div v-else>
									<p>{{ $t('rtr_pay-exchange.text5') }}</p>
									<p>
										{{ !selectedMarket ? 0 : selectedMarket.ask_spread_rate }} %
									</p>
								</div>
								<div>
									<p>{{ $t('rtr_pay-exchange.text6') }}</p>
									<p>
										{{
											!selectedMarket
												? 0
												: '1 ' +
												  selectedMarket.source_asset_code +
												  ' = ' +
												  selectedMarket.basic_rate +
												  ' ' +
												  selectedMarket.target_asset_code
										}}
									</p>
								</div>
								<div>
									<p>{{ $t('rtr_pay-exchange.text7') }}</p>
									<p>{{ exchangeRate }}</p>
								</div>
							</div>
							<div class="bottom_box">
								<div class="">
									<p v-if="selectedTab === 'BID'">
										{{ $t('rtr_pay-exchange.text2') }}
									</p>
									<p v-else>{{ $t('rtr_pay-exchange.text8') }}</p>
									<p class="fw_bold">{{ !sourceAmount ? 0 : sourceAmount }}</p>
								</div>
								<div class="mb_0">
									<p>{{ $t('rtr_pay-exchange.text3') }}</p>
									<p class="fw_bold">{{ targetAmount }}</p>
								</div>
							</div>
						</div>
						<div class="button_area tac">
							<!-- <button @click="initForm">{{ $t('button.cancel') }}</button> -->
							<button
								class="button_bg_blue"
								:disabled="!canExchange"
								@click="onDirectTransferHandler"
							>
								{{ $t('rtr_pay-exchange.title1') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModalView v-if="accountRegistModal" @closeModal="accountRegistModal = false">
		<h3 class="title mb_20">
			{{ $t('rtr_wallet_account-assets.title3') }}
		</h3>
		<AccountRegister
			@closeRegist="closeRegist"
			:asset-info="selectedAsset"
		></AccountRegister>
	</ModalView>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p v-if="messageModalMode === 'information'" class="status_text">
			<span class="fw_bold fc_red">{{ $t('rtr_pay-exchange.title1') }}</span>
			{{ $t('rtr_pay-exchange.text9') }}
		</p>
		<p v-else class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<!--			<button @click="initForm">-->
			<!--				{{ $t('rtr_auth-register.confirm') }}-->
			<!--			</button>-->
			<button class="fc_blue oneBtn" @click="toActivity">
				{{ $t('button.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'warning'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button
				class="fc_red"
				@click="(messageModal = false), (accountRegistModal = true)"
			>
				<!--			<button class="fc_red" @click="goRoute('account')">-->
				{{ $t('button.new_account') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="directTransfer">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import CustomSelectBox from '@/components/CustomSelectBox';
import ModalMessage from '@/components/Layout/ModalMessage';
import { mapGetters } from 'vuex';
import { createDirectTransfer, fetchDirectMarkets } from '@/api/market';
import { commonError } from '@/common/dialog';
import { uniqBy } from 'lodash';
import ModalView from '@/components/Layout/ModalView';
import AccountRegister from '@/components/AccountRegister';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';
import iconExchangeTitle from '@/assets/images/v2/icon/icon-exchange-title.svg';

export default {
	name: 'Exchange',
	components: {
		AccountRegister,
		ModalView,
		CustomSelectBox,
		ModalMessage,
		Tutorial,
	},
	data() {
		return {
			selectedTab: 'BID',
			markets: [],
			selectedSourceSeq: '',
			selectedTargetSeq: '',
			sourceAmount: null,
			accountRegistModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			newAssetSeq: '',
			selectedAssetSeq: null,
			target: '',
			tour: null,
			showTutorial: false,
			isMobile: false,
			iconExchangeTitle,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets']),
		sourceAssets() {
			let result = [];
			this.markets.forEach(market => {
				const asset = this.assets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		targetAssets() {
			let result = [];
			this.markets.forEach(market => {
				const asset = this.assets.find(asset => {
					return (
						market.source_asset_seq === this.selectedSourceSeq &&
						asset.seq === market.target_asset_seq
					);
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedSourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedTargetSeq;
			});
		},
		selectedMarket() {
			return this.markets.find(item => {
				return (
					item.source_asset_seq === this.selectedSourceSeq &&
					item.target_asset_seq === this.selectedTargetSeq
				);
			});
		},
		exchangeRate() {
			if (!this.selectedMarket) return 0;
			else return this.calcExchangeRate();
		},
		targetAmount() {
			if (!this.selectedTargetSeq) return 0;
			const decimalPoint = parseInt(
				this.assets.find(item => {
					return item.seq === this.selectedTargetSeq;
				}).decimal_point,
			);
			return (this.sourceAmount * this.exchangeRate).toFixed(decimalPoint);
		},
		canExchange() {
			if (this.selectedMarket && this.sourceAmount) return true;
			else return false;
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === this.selectedAssetSeq;
			});
		},
		sourcePlaceholder() {
			return this.selectedTab === 'BID'
				? this.$t('rtr_pay-exchange.text10')
				: this.$t('rtr_pay-exchange.text12');
		},
		targetPlaceholder() {
			return this.selectedTab === 'BID'
				? this.$t('rtr_pay-exchange.text11')
				: this.$t('rtr_pay-exchange.text13');
		},
		targetDisable() {
			return !this.selectedSourceAccount;
		},
		amountDisable() {
			return !(this.selectedSourceAccount && this.selectedTargetAccount);
		},
	},
	watch: {
		selectedSourceSeq() {
			this.selectedTargetSeq = '';
			this.$refs.targetSelect.initSelected();
		},
		selectedTab() {
			this.initForm();
		},
		sourceAmount(value) {
			if (!value) return;
			this.sourceAmount = value
				.replace(/[^0-9.]/g, '')
				.replace(/(\..*)\./g, '$1');
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadMarkets();
		},
		async loadMarkets() {
			const { data } = await fetchDirectMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		checkAccount(target) {
			const assetSeq =
				target === 'source' ? this.selectedSourceSeq : this.selectedTargetSeq;
			const account = this.accounts.find(item => {
				return item.asset_seq === assetSeq;
			});
			if (!account) {
				this.selectedAssetSeq = assetSeq;
				this.target = target;
				if (target === 'source') {
					this.newAssetSeq = this.selectedSourceSeq;
					this.selectedSourceSeq = '';
					this.$refs.sourceSelect.initSelected();
				} else {
					this.newAssetSeq = this.selectedTargetSeq;
					this.selectedTargetSeq = '';
					this.$refs.targetSelect.initSelected();
				}
				this.modalStatusMessage = this.$t('modal.message.no_account');
				this.modalIcon = 'warning';
				this.messageModalMode = 'warning';
				this.messageModal = true;
			}
		},
		selectSourceAsset(assetSeq) {
			this.selectedSourceSeq = assetSeq;
			this.checkAccount('source');
		},
		selectTargetAsset(assetSeq) {
			this.selectedTargetSeq = assetSeq;
			this.checkAccount('target');
		},
		calcExchangeRate() {
			const decimalPoint = parseInt(
				this.assets.find(item => {
					return item.seq === this.selectedTargetSeq;
				}).decimal_point,
			);
			const basicRate = parseFloat(this.selectedMarket.basic_rate).toFixed(
				decimalPoint,
			);
			switch (this.selectedTab) {
				case 'BID':
					return (
						basicRate *
						(this.selectedMarket.bid_spread_rate / 100 + 1)
					).toFixed(decimalPoint);
				case 'ASK':
					return (
						basicRate *
						(this.selectedMarket.ask_spread_rate / -100 + 1)
					).toFixed(decimalPoint);
				default:
					break;
			}
			return 0;
		},
		onDirectTransferHandler() {
			this.modalIcon = 'information';
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		directTransfer() {
			this.messageModal = false;
			const data = {
				market_seq: this.selectedMarket.seq,
				source_account_seq: this.selectedSourceAccount.seq,
				target_account_seq: this.selectedTargetAccount.seq,
				transfer_type: this.selectedTab,
				source_amount: this.sourceAmount,
			};
			createDirectTransfer(data)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.modalStatusMessage = this.$t('modal.message.success_exchange');
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		closeRegist(seq) {
			if (seq) {
				const accountInfo = this.accounts.find(item => {
					return item.seq === seq;
				});
				this.target === 'source'
					? this.$refs.sourceSelect.selectItem(accountInfo.asset_seq)
					: this.$refs.targetSelect.selectItem(accountInfo.asset_seq);
			}
			this.accountRegistModal = false;
		},
		initForm() {
			this.messageModal = false;
			this.selectedSourceSeq = '';
			this.selectedTargetSeq = '';
			this.sourceAmount = null;
			this.$refs.sourceSelect.initSelected();
			this.$refs.targetSelect.initSelected();
		},
		goRoute(name) {
			this.messageModal = false;
			switch (name) {
				case 'dashboard':
					this.$router.push({ name: 'auth-dashboard' });
					break;
				case 'account':
					this.$router.push({
						name: 'wallet_account-assets',
						query: { assetSeq: this.newAssetSeq },
					});
					break;
				case 'checkAmount':
					this.$router.push({
						name: 'wallet_account-assets',
						query: { assetSeq: this.selectedSourceSeq },
					});
					break;
			}
		},
		toActivity() {
			this.$router.push({
				name: 'activity-exchange',
			});
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
		this.tutorialHandler();
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
};
</script>
<style scoped></style>
